var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"cross"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square","key":2},React.createElement("g",{"id":"Mobile_menu","transform":"translate(-329.000000, -28.000000)","fillRule":"nonzero","stroke":"#FFFFFF"},React.createElement("g",{"id":"cross","transform":"translate(330.000000, 28.000000)"},[React.createElement("path",{"d":"M0.555555556,0.555555556 L18.8973045,18.8973045","id":"Line","key":0}),React.createElement("path",{"d":"M0,19 L19,0","id":"Line","key":1})])))]);
}

CrossInline.defaultProps = {"width":"21px","height":"19px","viewBox":"0 0 21 19","version":"1.1"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
